import React from "react";
import styles from "../style.module.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.footerInfo}>
          <h4>LET'S WORK TOGETHER</h4>
          <a href="mailto:support@aaerlaw.com" className={styles.mailLink}>
            support@aaerlaw.com
          </a>
          <div className={styles.socials}>
            <div className={styles.socialIcon}>
              <a
                href="https://web.facebook.com/aaerlaw/?_rdc=1&_rdr#"
                target="_blank"
                rel="noreferrer"
                className="facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
            <div className={styles.socialIcon}>
              <a
                href="https://x.com/aaerlaw?s=11&t=9J1i7mo1wHbkevEaQ6uQww"
                target="_blank"
                rel="noreferrer"
                className="twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
            </div>
            <div className={styles.socialIcon}>
              <a
                href="https://www.instagram.com/aaerlaw?igsh=Z2FhcHg5cTB2cWhj"
                target="_blank"
                rel="noreferrer"
                className="instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
            <div className={styles.socialIcon}>
              <a
                href="https://www.linkedin.com/newsletters/7243994589437558784/?displayConfirmation=true"
                target="_blank"
                rel="noreferrer"
                className="linkedin"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
            <div className={styles.socialIcon}>
              <a
                href="https://www.tiktok.com/@aaerlaw?_r=1&_t=ZS-95cXOJFGO0a"
                target="_blank"
                rel="noreferrer"
                className="tiktok"
              >
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>

        <div className={styles.footerItems}>
          <div className={styles.rightsText}>
            &copy; {new Date().getFullYear()} AAERLAW All Rights Reserved.
          </div>
          <div className={styles.footerLinks}>
            <Link to="/faq">FAQ</Link>
            <Link to="/about">About</Link>
            <Link to="/team">Our Team</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact us</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
